module.exports = __webpack_public_path__ + "home_type_ico_1.svg?97117745429ec85c5634f668f1f04b2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_type_ico_1.svg
// module id = 21
// module chunks = 0